module.exports = __webpack_public_path__ + "img/cp-22.cca4fe94.png";